export default __webpack_public_path__ + "static/media/top-ten-block-9.7cb05ad1.svg";